<template>
  <div class="container">
    <Head :showBorder="1" />
    <div class="pic-div">
      <img class="pic1" src="../assets/pic1.jpg" alt="" />
      <img class="pic2" src="../assets/pic2.jpg" alt="" />
      <img class="pic3" src="../assets/pic3.jpg" alt="" />
    </div>
    <div class="mid-box">
      <div class="mid-box-tit">城市级全视频路内外智慧停车的技术发展趋势</div>
      <div class="mid-box-text">Development Trend</div>
      <div class="mid-box-wire"></div>
      <div class="mid-box-bottom">
        <div class="mid-box-bottom-div">
          <div>路内外停车管理一体化成为主流模式</div>
          <p>
            特别是中国各地以“城市大脑”为依托大力提倡智慧城市建设的背景下，在不久的未来将会有很多城市逐步借鉴推广。
          </p>
        </div>
        <div class="mid-box-bottom-div">
          <div>一线停车管理更多地实现人机结合</div>
          <p>
            不单靠机器，也靠人。市场前线管理方面，做到了有机结合，形成了制度化、流程化与平台化。
          </p>
        </div>
        <div class="mid-box-bottom-div">
          <div>城市级停车应用的整合与分工</div>
          <p>
            很多城市在过去由各区县各自研发APP；进行资源整合后，根据地方政府的要求，由开发者定向开发，向政府无偿交付城市级停车APP，各区县建设前端设备进行数据采集，提供现场停车管理服务，数据最后统一传输至中心城市（运营管理中心），这样做既提高了城市管理效率，也减少了投资浪费。
          </p>
        </div>
        <div class="mid-box-bottom-div">
          <div>平台服务需要统一与延伸</div>
          <p>
            过去很多地方政府由于管理方式的差异化，路内外停车有很多平台，但由于缺乏后期服务，很多地方都没有运营好，政府迫切需要掌握城市停车数据利用在城市管理当中；通过路内外停车管理一体化平台，可实现政府及各职能部门对城市停车大数据的采集，提升城市的信息化管理水平，为城市交通、规划和城市管理部门提供基础数据和决策依据。
          </p>
        </div>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
import Head from "@/view/module/head.vue";
import Bottom from "@/view/module/bottom.vue";
export default {
  name: "index",
  data() {
    return {};
  },
  components: {
    Head,
    Bottom
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mid-box-bottom-div:hover p {
  display: block;
}
.mid-box-bottom-div p {
  font-family: "PingFang SC";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  display: none;
  line-height: 23px;
  color: #ffffff;
}
.mid-box-bottom-div-tit {
  margin-bottom: 20px;
}
.mid-box-bottom-div div{
  font-family: 'YouSheBiaoTiHei';
  font-style: normal;
  font-weight: 400;
}
.mid-box-bottom-div {
  width: 300px;
  color: #fff;
  text-align: left;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  padding: 24px 16px;
  font-size: 24px;
  float: left;
  margin-right: 24px;
}
.mid-box-bottom-div:nth-child(4) {
  margin-right: 0px;
}
.mid-box-bottom {
  margin-top: 42px;
  display: inline-block;
}
.mid-box-wire {
  width: 614px;
  height: 1px;
  margin-top: 32px;
  margin: auto;
  background-color: #fff;
}
.mid-box-text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  margin-bottom: 32px;
  color: #ffffff;
}
.mid-box-tit {
  font-family: "YouSheBiaoTiHei";
  font-style: normal;
  font-weight: 400;
  font-size: 48px;
  padding-top: 287px;
  padding-bottom: 20px;
  color: #ffffff;
}
.mid-box {
  background: url("../assets/midPic.jpg") no-repeat;
  background-size: 100% 100%;
  height: 980px;
}
.pic3 {
  width: 100%;
  /* height: 1024px; */
}
.pic-div {
  display: grid;
}
.pic1 {
  width: 100%;
  /* height: 1014px; */
}
.pic2 {
  width: 100%;
  /* height: 1024px; */
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue